window.changeCurrency = function (value) {
    let selectedCurrency = window.currencyRate[value];
    if (typeof selectedCurrency !== "undefined") {
        let prices = document.querySelectorAll('[data-cprice]');
        let symbol = document.querySelectorAll('[data-csymbol]');
        prices.forEach(function (elem) {
            let curPrice = elem.dataset.cprice;
            let curNewPrice = parseInt(curPrice) * selectedCurrency.rate;
            if (isNaN(curNewPrice))
                curNewPrice = 0;
            //elem.innerText = new Intl.NumberFormat('de-DE', {style: 'currency', currency: value}).format(curNewPrice);
            /*elem.innerText = new Intl.NumberFormat(window.currentLang.toLowerCase(), {
                style: 'currency',
                currency: value,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(curNewPrice);*/
            elem.innerText = new Intl.NumberFormat("ru", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(curNewPrice) + ` ${selectedCurrency.symbol}`;
        })
        symbol.forEach(function (elem) {
            elem.innerText = selectedCurrency.symbol;
        });
    }
}
